import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import { TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  currentDateAndTime,
  decodeData,
  formatDateWithTime,
  offerLetterCheatCode,
} from "../../Constants/constants";
import copy from "clipboard-copy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TooltipComponent from "../../Components/TooltipComponent";

class InductionProcess extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      location_title: "",
      location_description: "",
      rows: [],
      logs_rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      doc_next: false,
      doc_prev: false,
      doc_page: 1,
      doc_limit: 10,
      doc_total_records: 0,
      doc_total_pages: 0,
      loadingList: false,
      postLoading: false,
      loadingSearch: false,
      loadingFinalSubmit: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      errors: [],
      email_preview: "",
      infoLoading: false,
      isLetterModal: false,
      company_letter_title: "",
      company_letter_head_id: "",
      company_letter_content: "",
      markings: "",
      letterhead_url: "",
      emailList: false,
      email_next: false,
      email_prev: false,
      email_page: 1,
      email_limit: 10,
      email_total_records: 0,
      email_total_pages: 0,
      emailEdit: false,
      email_rows: [],
      mailTemplateTitle: "",
      mailSubject: "",
      mailBody: "",
      isEmailModal: "",
      resendEmail: false,
      selectedEmailTemplate: "",
      emailPreviewClicked: false,
      viewOfferLetterInfo: false,
      viewOfferLetterLogs: false,
      allowances: [],
      letter_rows: [],
      logs_details_rows: [],
      employee_name: "",
      candidateDesignation: "",
      candidateDepartment: "",
      candidateGrade: "",
      candidateLocation: "",
      employee_joining_date: "",
      selectedInfoTab: "1",
      isCandidateDetails: "1",
      policyRows: [],
      selectedPolicyRows: [],
      candidateId: "",
      isEmailSend: "1",
      guest_employee_id: "",
      loadingSendEmail: false,
      loadingGuestList: false,
      letter_next: false,
      letter_prev: false,
      letter_page: 1,
      letter_limit: 10,
      letter_total_records: 0,
      letter_total_pages: 0,
      letter_preview: "",
      company_policy_title: "",
      company_policy_content_type: "",
      policy_content: "",
      policy_url: "",
      isPolicyModal: "",
      loadingFilter: "",
      decodedData: [],
    };
  }

  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      // this.GetPolicyList();
      this.getEmailTemplateList();
      // this.getLetterTemplateList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          console.log("decodedData===>",decodedData)
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }

  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetAppointmentLetterAcceptedEmployeeList`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          console.log("GetAppointmentLetterAcceptedEmployeeList =>", data);
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingSearch: false,
            loadingFilter: false,
          });
        } else {
          this.setState({
            loadingList: false,
            loadingSearch: false,
            loadingFilter: false,
          });
        }
      })
      .catch((error) => {
        this.setState({ loadingList: false, loadingSearch: false });
      });
  };
  GetGuestDataList = (row) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetSendInductionToEmployeeLogs`, {
        params: {
          guest_employee_id: row?.guest_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          console.log("GetSendInductionToEmployeeLogs =>", data);
          // this.GetLogList(row?.guest_employee_id);
          this.setState({
            logs_rows: data,
            // next: data.next,
            // prev: data.prev,
            // page: data.page,
            // total_records: data.total_records,
            // total_pages: data.total_pages,
            viewOfferLetterLogs: `${row?.guest_employee_id}`,
            candidateId: row?.guest_employee_id,
            employee_name: row?.employee_name,
            candidateDesignation: row?.designation_title,
            candidateDepartment: row?.department_title,
            candidateGrade: row?.grade_title,
            candidateLocation: row?.location_title,
            employee_joining_date: row?.employee_joining_date,
            guest_employee_id: row?.guest_employee_id,
            loadingGuestList: false,
          });
        } else {
          this.setState({ loadingGuestList: false });
        }
      })
      .catch((error) => {
        this.setState({ loadingGuestList: false });
        console.log("Employees/GetEmployeesCollectedData ERROR:", error);
        Swal.fire({
          title: `<strong>Failed</strong>`,
          text: "Opps...! Something went wrong!",
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      });
  };
  GetPolicyList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetCompanyPolicyList`, {
        params: {
          guest_employee_id: this.state.guest_employee_id,
          limit: this.state.doc_limit,
          page: this.state.doc_page,
        },
        headers,
      })
      .then((response) => {
        const data = response.data?.response;
        console.log("GetPolicyList", data);
        if (data?.success === true) {
          // const makeInt= data?.employee_document?.map((val)=>{
          //     return parseInt(val);
          // })
          console.log("data?.employee_document ");
          this.setState(
            {
              policyRows: data?.data || [],
              selectedPolicyRows: data?.employee_policies || [],
              doc_next: data?.next,
              doc_prev: data?.prev,
              doc_page: data?.page,
              doc_total_records: data?.total_records,
              doc_total_pages: data?.total_pages,
              loadingList: false,
              resendEmail: true,
            },
            () => {
              // console.log(this.state.policyRows, this.state.selectedPolicyRows);
            }
          );
        } else {
          this.setState({ loadingList: false });
          Swal.fire({
            title: `<strong>${"Failed"}</strong>`,
            text: "Opps...! Something went wrong!",
            icon: "error",
            showConfirmButton: true,
            allowOutsideClick: false,
          });
        }
      });
  };
  GetLogList = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(
        `${apiURL}Employees/GetSendAppointmentLetterLogs?guest_employee_id=${id}`,
        {
          headers,
        }
      )
      .then((response) => {
        var data = response.data;
        console.log("GetLogList", data);
        if (response.data.success === true) {
          this.setState({
            logs_details_rows: data,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  getEmailTemplateList = async () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}MailMaster/GetMailTemplateList`, {
        params: {
          limit: this.state.email_limit,
          page: this.state.email_page,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log(response?.data);
        if (response.data.success === true) {
          this.setState({
            email_rows: data?.response?.data,
            email_next: data?.response?.next ?? false,
            email_prev: data?.response?.prev ?? false,
            email_page: data?.response?.page ? data?.response?.page : 1,
            email_total_records: data?.response?.total_records
              ? data?.response?.total_records
              : 0,
            email_total_pages: data?.response?.total_pages
              ? data?.response?.total_pages
              : 0,
            loadingList: false,
          });
        } else {
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };

  getLetterTemplateList = async () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetCompanyLettersList`, {
        params: {
          limit: this.state.letter_limit,
          page: this.state.letter_page,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log(data);
        if (response.data.success === true) {
          this.setState({
            letter_rows: data.data,
            letter_next: data.next || false,
            letter_prev: data.prev || false,
            letter_page: data.page || 1,
            letter_total_records: data.total_records,
            letter_total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };
  GetLetterInfoSet = (idx) => {
    this.setState({
      company_letter_title: this.state.letter_rows[idx]?.company_letter_title,
      company_letter_head_id:
        this.state.letter_rows[idx]?.company_letter_head_id,
      company_letter_content:
        this.state.letter_rows[idx]?.company_letter_content,
      markings: this.state.letter_rows[idx]?.markings || "0,0,0,0",
      letterhead_url: this.state.letter_rows[idx]?.letterhead_url || null,
      isLetterModal: `${idx}`,
    });
  };
  handleEditorChange = (event, editor) => {
    // const value = event.target.value;

    // Clear the previous timeout if the user is still typing
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timeout to call the function after 1 second
    this.debounceTimer = setTimeout(() => {
      const company_letter_content = editor.getData();
      // Clear the error for the company_letter_content field
      const errorsList = { ...this.state.errors };
      delete errorsList.company_letter_content;

      this.setState({
        company_letter_content: company_letter_content,
        errors: errorsList, // Update errors object
      });
    }, 1000);
  };
  handleLetter = () => {
    const temp = [...this.state.letter_rows]; // Create a shallow copy of the array
    //   console.log(this.state.company_letter_content)
    const index = parseInt(this.state.isLetterModal); // Index of the element to update
    if (index >= 0 && index < temp.length) {
      // Update the specific element at the given index
      temp[index] = {
        ...temp[index],
        // company_letter_head_id: this.state.company_letter_head_id,
        // company_letter_title: this.state.company_letter_title,
        company_letter_content: this.state.company_letter_content,
      };
    }

    // Debugging: Log the updated value for verification
    console.log("Updated element:", temp[index]);

    // Update the state with the modified array
    this.setState({ letter_rows: temp, letterEdit: false }, () =>
      console.log("Updated letter_rows:", this.state.letter_rows)
    );
  };

  getCandidateInfo = () => {
    const { apiHeaderJSON, apiURL } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    axios
      .get(`${apiURL}Employees/GetProfile?employee_id=${employee_id}`, {
        headers,
      })
      .then((response) => {
        var data = response.data.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.documents || [],
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  getInfo = (id, idx) => {
    this.setState({
      infoLoading: false,
      emailList: id,
      isEmailModal: `${idx}`,
      mailTemplateTitle: this.state.email_rows[idx]?.mail_template_title,
      mailSubject: this.state.email_rows[idx]?.mail_subject,
      mailBody: this.state.email_rows[idx]?.mail_body,
    });
  };
  getEmailInfo = (id, idx) => {
    this.setState({
      infoLoading: false,
      emailList: id,
      isEmailModal: `${idx}`,
      mailTemplateTitle:
        this.state.logs_rows?.employee_mail_details[idx]?.mail_template_title,
      mailSubject:
        this.state.logs_rows?.employee_mail_details[idx]?.email_subject,
      mailBody:
        this.state.logs_rows?.employee_mail_details[idx]?.employee_mail_content,
    });
  };

  renderPages(company_letter_content, letterhead_url, markings) {
    // const { company_letter_content, letterhead_url, markings } = this.state;
    const pageHeight = 297;
    const marginTop = parseInt(markings.split(",")[0] || 0, 10);
    const marginBottom = parseInt(markings.split(",")[1] || 0, 10);
    const marginLeft = parseInt(markings.split(",")[3] || 0, 10);
    const marginRight = parseInt(markings.split(",")[2] || 0, 10);

    const contentHeight = pageHeight - marginTop - marginBottom;

    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.width = "210mm";
    tempDiv.style.visibility = "hidden";
    tempDiv.style.fontSize = "14px";
    tempDiv.innerHTML = company_letter_content;

    document.body.appendChild(tempDiv);

    const pages = [];
    let currentPage = "";
    let totalHeight = 0;

    Array.from(tempDiv.childNodes).forEach((node) => {
      const clone = node.cloneNode(true);
      tempDiv.innerHTML = "";
      tempDiv.appendChild(clone);

      const nodeHeight = tempDiv.scrollHeight / 3.77953;
      totalHeight += nodeHeight;

      if (totalHeight <= contentHeight) {
        currentPage += node.outerHTML;
      } else {
        pages.push(currentPage);
        currentPage = node.outerHTML;
        totalHeight = nodeHeight;
      }
    });

    if (currentPage) pages.push(currentPage);

    document.body.removeChild(tempDiv);

    return pages.map((pageContent, index) => (
      <div
        key={index}
        className="bubble-editor"
        style={{
          position: "relative",
          // width: "210mm",
          height: `${pageHeight}mm`,
          // marginTop: `${marginTop}mm`,
          // marginBottom: `${marginBottom}mm`,
          border: "1px solid #F3F3F9",
        }}
      >
        {letterhead_url && (
          <img
            src={letterhead_url}
            alt="Letterhead"
            style={{ position: "absolute", width: "100%", height: "297mm" }}
          />
        )}
        <div
          dangerouslySetInnerHTML={{ __html: pageContent }}
          style={{
            position: "relative",
            paddingTop: `${marginTop}mm`,
            paddingBottom: `${marginBottom}mm`,
            paddingLeft: `${marginLeft}mm`,
            paddingRight: `${marginRight}mm`,
            boxSizing: "border-box",
            background: "transparent",
          }}
        />
      </div>
    ));
  }
  GetLetterInfo = (idx) => {
    // console.log(`this.state.logs_details_rows?.employee_letter_details[idx]`,this.state.logs_details_rows?.employee_letter_details[idx])
    this.setState({
      company_letter_title:
        this.state.logs_details_rows?.employee_letter_details[idx]
          ?.company_letter_title,
      company_letter_head_id:
        this.state.logs_details_rows?.employee_letter_details[idx]
          ?.company_letter_head_id,
      company_letter_content:
        this.state.logs_details_rows?.employee_letter_details[idx]
          ?.employee_letter_content,
      markings:
        this.state.logs_details_rows?.employee_letter_details[idx]?.markings ||
        "0,0,0,0",
      letterhead_url:
        this.state.logs_details_rows?.employee_letter_details[idx]
          ?.letterhead_url || null,
      isLetterModal: `${idx}`,
    });
  };
  handleCopyClick = (code) => {
    copy(code);
    toast.success(`Code Has Been Copied! ${code}`, { autoClose: 1500 });
  };

  handleFinalSubmit = (type) => {
    const formData = {};
    const { apiHeaderFile, apiURL } = this.context;
    const headers = apiHeaderFile;

    Swal.fire({
      title: "Are you sure?",
      text: `You want to verify ${type === "1" ? "all details" : "documents"}!`,
      icon: "warning",
      showCancelButton: true,
      // confirmButtonColor: "#3085d6",
      // cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Verify!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ loadingFinalSubmit: true });
        axios
          .post(`${apiURL}Employees/VerifyEmployeeDetails`, formData, {
            params: {
              date: currentDateAndTime(),
              guest_employee_id: this.state.guest_employee_id,
              verification_type: type,
            },
            headers,
          })
          .then((response) => {
            const data = response.data;
            if (response.data.success === true) {
              console.log("VerifyEmployeeDetails =>", data);
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });

              this.setState({ loadingFinalSubmit: false }, () => {
                this.GetList();
              });
            } else {
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Set your state here
                  if (data?.missing_step) {
                    this.setState({ selectedInfoTab: `${data?.missing_step}` });
                  }
                }
              });
              this.setState({ loadingFinalSubmit: false });
            }
          })
          .catch((error) => {
            this.setState({ loadingFinalSubmit: false });
            Swal.fire({
              title: `<strong>${"Failed"}</strong>`,
              text: "Opps...! Something went wrong!",
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
            console.error("Error uploading file:", error);
          });
      }
    });
  };

  GetPolicyInfoSet = (idx) => {
    console.log(
      `this.state.policyRows[idx]?.company_policy_document_url`,
      this.state.policyRows[idx]?.company_policy_document_url
    );
    this.setState({
      company_policy_title:
        this.state.policyRows[idx]?.company_policy_title || "",
      company_policy_content_type:
        this.state.policyRows[idx]?.company_policy_content_type || "",
      policy_content: this.state.policyRows[idx]?.company_policy_content || "",
      policy_url: this.state.policyRows[idx]?.company_policy_document_url || "",
      isPolicyModal: `${idx}`,
    });
  };

  handleEditorEmailChange = (event, editor) => {
    // const value = event.target.value;

    // Clear the previous timeout if the user is still typing
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timeout to call the function after 1 second
    this.debounceTimer = setTimeout(() => {
      const mailBody = editor.getData();
      // Clear the error for the mailBody field
      const errorsList = { ...this.state.errors };
      delete errorsList.mailBody;

      this.setState({
        mailBody: mailBody,
        errors: errorsList, // Update errors object
      });
    }, 1000);
  };
  handleEmail = () => {
    const temp = [...this.state.email_rows]; // Create a shallow copy of the array

    const index = parseInt(this.state.isEmailModal); // Index of the element to update
    if (index >= 0 && index < temp.length) {
      // Update the specific element at the given index
      temp[index] = {
        ...temp[index],
        mail_body: this.state.mailBody,
        mail_template_title: this.state.mailTemplateTitle,
        mail_subject: this.state.mailSubject,
      };
    }

    // Debugging: Log the updated value for verification
    console.log("Updated element:", temp[index]);

    // Update the state with the modified array
    this.setState({ email_rows: temp, emailEdit: false }, () =>
      console.log("Updated email_rows:", this.state.email_rows)
    );
  };

  templatePreview = (templateType) => {
    const replaceCheatCodeList = [
      {
        cheat_code: "##current_date##",
        value: formatDateWithTime()?.split(" ")[0],
      },
      { cheat_code: "##employee_name##", value: this.state.employee_name },
      {
        cheat_code: "##department_title##",
        value: this.state.candidateDepartment,
      },
      {
        cheat_code: "##designation_title##",
        value: this.state.candidateDesignation,
      },
      { cheat_code: "##grade_title##", value: this.state.candidateGrade },
      { cheat_code: "##location_title##", value: this.state.candidateLocation },
      {
        cheat_code: "##employee_joining_date##",
        value: formatDateWithTime(this.state.employee_joining_date)?.split(
          " "
        )[0],
      },
    ];
    if (templateType === "letter") {
      let letter = this.previewTemplate(
        this.state.company_letter_content,
        replaceCheatCodeList
      );
      console.log(" letter preview:", letter);
      this.setState({ letter_preview: letter });
    }
    // console.log(" this.state.employee_name preview:", this.state.employee_name);
    if (templateType === "email") {
      let email = this.previewTemplate(
        this.state.mailBody,
        replaceCheatCodeList
      );
      //   console.log(" email preview:", email);

      this.setState({ email_preview: email });
    }
  };

  previewTemplate = (inputString, cheatCodeArray) => {
    if (!inputString || !cheatCodeArray || !Array.isArray(cheatCodeArray)) {
      throw new Error(
        "Invalid input: Provide a valid string and cheatCodeArray"
      );
    }

    return cheatCodeArray.reduce((updatedString, { cheat_code, value }) => {
      if (cheat_code && value) {
        const regex = new RegExp(cheat_code, "g"); // Use 'g' flag for global replacement
        return updatedString.replace(regex, value);
      }
      return updatedString;
    }, inputString);
  };

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployee`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${
                response.data.success === true ? "Success" : "Failed"
              }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          });
      }
    });
  };

  handleSendEmail = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const emails = this.state.email_rows.filter((val) => {
      if (this.state.selectedEmailTemplate == val?.mail_template_id) {
        return val;
      }
    });

    Swal.fire({
      title: "Are you sure?",
      text: `You want to send an email!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ loadingSendEmail: true });
        const data = {
          email_template: emails,
          policies: this.state.selectedPolicyRows,
          // required_letters: letter,
          date: currentDateAndTime(),
          guest_employee_id: this.state.guest_employee_id,
        };
        if (result.value) {
          data.employee_code = result.value;
        } else {
          data.employee_code = "";
        }
        console.log(data);
        axios
          .post(`${apiURL}Employees/SendInductionToEmployee`, data, { headers })
          .then((response) => {
            const { success } = response.data;
            console.log("SendInductionToEmployee =>", response);
            if (success === true) {
              this.setState({
                isLetterModal: false,
                letterEdit: false,
                previewClicked: false,
                resendEmail: false,
                isEmailSend: "1",
                selectedEmailTemplate: "",
                selectedPolicyRows: "",
                emailEdit: false,
                emailPreviewClicked: false,
                emailList: false,
                loadingSendEmail: false,
              });
              this.GetList();
              // this.GetLogList();
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });
            } else {
              this.setState({
                loadingSendEmail: false,
              });
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });
            }
          })
          .catch((error) => {
            this.setState({
              loadingSendEmail: false,
            });
            Swal.fire({
              title: `<strong>Failed</strong>`,
              text: error?.response?.data?.message,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          });
      }
    });
  };

  handleInputSearch = (e) => {
    this.setState({ loadingSearch: true }, () => {
      this.GetList();
    });
  };

  handleEmailInputChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleInputChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (this.state.keyword === "") {
          this.GetList();
        }
      }
    );
  };
  handleDateChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSelectChange = (selectedOption) => {
    this.setState({ selectOption: selectedOption });
  };

  // handleCheckboxChange = (employee_document_type_id) => {
  //   this.setState((prevState) => {
  //     const selectedPolicyRows = [...prevState.selectedPolicyRows];

  //     if (selectedPolicyRows.includes(employee_document_type_id)) {
  //       selectedPolicyRows.splice(
  //         selectedPolicyRows.indexOf(employee_document_type_id),
  //         1
  //       );
  //     } else {
  //       selectedPolicyRows.push(employee_document_type_id);
  //     }

  //     return { selectedPolicyRows };
  //   });
  // };

  // handleSelectAll = () => {
  //   this.setState((prevState) => {
  //     const selectedPolicyRows =
  //       prevState.selectedPolicyRows.length === prevState.policyRows.length
  //         ? []
  //         : prevState.policyRows.map((row) => row.company_policy_id);

  //     return { selectedPolicyRows };
  //   });
  // };

  // handleSelectAllDropdown = (action) => {
  //   if (action === "select-all") {
  //     this.setState({
  //       selectedPolicyRows: this.state.policyRows.map(
  //         (row) => row.employee_document_type_id
  //       ),
  //     });
  //   } else if (action === "deselect-all") {
  //     this.setState({ selectedPolicyRows: [] });
  //   }
  // };
  handleCheckboxChange = (company_policy_id, title) => {
    this.setState((prevState) => {
      const selectedPolicyRows = [...prevState.selectedPolicyRows];

      const existingIndex = selectedPolicyRows.findIndex(
        (item) => item.company_policy_id === company_policy_id
      );

      if (existingIndex !== -1) {
        // If the item exists, remove it
        selectedPolicyRows.splice(existingIndex, 1);
      } else {
        // If the item does not exist, add it
        selectedPolicyRows.push({
          company_policy_id: company_policy_id,
          company_policy_title: title,
        });
      }
      console.log("selectedPolicyRows", selectedPolicyRows);
      return { selectedPolicyRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedPolicyRows =
        prevState.selectedPolicyRows.length === prevState.policyRows.length
          ? []
          : prevState.policyRows.map((row) => ({
              company_policy_id: row.company_policy_id,
              company_policy_title: row.company_policy_title, // Update to use the correct title property
            }));

      return { selectedPolicyRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === "select-all") {
      this.setState({
        selectedPolicyRows: this.state.policyRows.map((row) => ({
          id: row.company_policy_id,
          title: row.company_policy_title, // Update to use the correct title property
        })),
      });
    } else if (action === "deselect-all") {
      this.setState({ selectedPolicyRows: [] });
    }
  };

  //   componentDidUpdate() {
  //     console.log(this.state.selectedPolicyRows);
  //   }

  handleClearAll = () => {
    this.setState(
      {
        employee_id: 0,
        location_title: "",
        location_description: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
        keyword: "",
        from_date: "",
        to_date: "",
        selectOption: "",
      },
      () => {
        this.GetList();
      }
    );
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };

  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };

  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Induction Process`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {/* <div style={{ width: "60%", margin: "auto" }}>
                      <div className=" position-relative alert alert-danger mt-3" role="alert">
                          This page is under development.
                      </div>
                  </div> */}
                  <div className="card-header ">
                    <div className="row col-md-12">
                      <div className="col-md-3">
                        <label htmlFor="keyword">Candidate Name</label>
                        <div className="input-group">
                          <input
                            type="search"
                            className="form-control"
                            onChange={this.handleInputChange}
                            name="keyword"
                            value={this.state.keyword}
                            aria-label="Recipient's username"
                            aria-describedby="button-addon2"
                            placeholder="Search Name"
                          />
                          <button
                            className="btn btn-success"
                            onClick={() => {
                              if (
                                this.state.keyword &&
                                !this.state.loadingSearch
                              ) {
                                this.handleInputSearch();
                              }
                            }}
                            type="button"
                            id="button-addon2"
                          >
                            {this.state.loadingSearch ? (
                              <span
                                class="spinner-border flex-shrink-0"
                                role="status"
                                style={{
                                  width: "0.8rem",
                                  height: "0.8rem",
                                  borderWidth: "2px",
                                }}
                              >
                                <span class="visually-hidden">Loading...</span>
                              </span>
                            ) : (
                              <i className="ri-search-line"></i>
                            )}
                          </button>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <TextBox
                          type="Date"
                          id="from_date"
                          name="from_date"
                          label="Induction From Date"
                          value={this.state.from_date}
                          change={this.handleDateChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <TextBox
                          type="Date"
                          id="to_date"
                          name="to_date"
                          label="Induction To Date"
                          value={this.state.to_date}
                          change={this.handleDateChange}
                        />
                      </div>
                      <div style={{ width: "11%" }} className="col-md-2">
                        <div>
                          <label>Apply Filter</label>
                        </div>
                        {this.state.loadingFilter === "1" ? (
                          <button className="btn btn-info btn-load">
                            <span className="d-flex align-items-center">
                              <span
                                className="spinner-border flex-shrink-0"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </span>
                              <span className="flex-grow-1 ms-2">
                                Loading...
                              </span>
                            </span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              this.setState(
                                {
                                  loadingFilter: "1",
                                },
                                () => {
                                  this.handleInputSearch();
                                  console.log(
                                    "this.state.loadingFilter1 ==>",
                                    this.state.loadingFilter
                                  );
                                }
                              );

                              // console.log("this.state.loadingFilter ==>" + this.state.loadingFilter);
                            }}
                            className={`w-100 btn btn-info btn-label waves-effect waves-light ${
                              !this.state.keyword &&
                              this.state.from_date === "" &&
                              this.state.to_date === "" &&
                              this.state.selectOption === "" &&
                              !this.state.filter_leave_type_id
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                            Filter
                          </button>
                        )}
                      </div>
                      <div style={{ width: "11%" }} className="col-md-2">
                        <div>
                          <label className=" noWrap">Clear Filter</label>
                        </div>
                        {this.state.loadingFilter === "2" ? (
                          <button className="btn btn-secondary btn-load">
                            <span className="d-flex align-items-center">
                              <span
                                className="spinner-border flex-shrink-0"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </span>
                              <span className="flex-grow-1 ms-2">
                                Loading...
                              </span>
                            </span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className={`btn w-100 noWrap btn-secondary btn-label waves-effect waves-light ${
                              !this.state.keyword &&
                              this.state.from_date === "" &&
                              this.state.selectOption === "" &&
                              this.state.to_date === "" &&
                              !this.state.filter_leave_type_id
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => {
                              this.setState({ loadingFilter: "2" }, () => {
                                this.handleClearAll();
                                console.log(
                                  "this.state.loadingFilter1 ==>",
                                  this.state.loadingFilter
                                );
                              });
                            }}
                          >
                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i>{" "}
                            Clear
                          </button>
                        )}
                      </div>
                      {/* <div className='col-md-3'>
                            <div>
                            <label>Show All </label>
                            </div>
                            <button
                            type="button"
                            className={`btn btn-secondary noWrap btn-sm btn-label right ms-auto ${(!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption) ? 'disabled' : ''}`}
                            onClick={this.handleClearAll}
                            disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption}
                            >
                            <i className=" ri-database-2-line label-icon align-middle fs-16 ms-2"></i> Show All
                            </button>
                        </div> */}
                    </div>
                  </div>
                  <div className="card-body">
                    <table className={`table table-bordered table-stripped`}>
                      <thead className="table-light">
                        <tr>
                          <th>Issued Date</th>
                          <th>Contact No.</th>
                          <th>Candidate Name</th>
                          <th>Personal Email</th>
                          <th>Location</th>
                          <th>Department</th>
                          <th>Policy Status</th>
                          { (this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3)) && (
                          <th className="text-center">Action</th>)}
                        </tr>
                      </thead>
                      {this.state.rows.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan={11}>
                              <NoRecords />
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {this.state.rows.map((row) => {
                            return (
                              <tr key={row?.guest_employee_id}>
                                <td>
                                  {row?.induction_send_date_time
                                    ? formatDateWithTime(
                                        row?.induction_send_date_time
                                      )
                                    : "--"}
                                </td>
                                <td>{row?.employee_mobile_number}</td>
                                <td>{row?.employee_name}</td>
                                {/* <td>
                                  <NavLink to={`/Profile/${row?.guest_employee_id}`}>
                                    {row?.employee_name}
                                  </NavLink>
                                </td> */}
                                <td>{row?.employee_email_address || "--"}</td>
                                <td>{row?.location_title}</td>
                                <td>{row?.department_title}</td>
                                <td>
                                  <div
                                    style={{ fontSize: "0.65rem" }}
                                    className={` bg-${row?.inductionStatusClasses} fw-semibold px-1 text-center py-1 text-white rounded-4`}
                                  >
                                    {row?.inductionStatus}
                                  </div>
                                </td>
                                { (this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3)) && (
                                <td className="d-flex justify-content-around gap-2">
                                  {/* <button
                                    onClick={() => this.setState({ viewOfferLetterInfo: row?.guest_employee_id })} 
                                    className="btn-icon btn btn-sm btn-outline-danger"
                                  >
                                    <i className="ri-mail-close-line"></i>
                                  </button> */}
                                  { this.state.decodedData?.includes(1) && (
                                  <TooltipComponent
                                    name="View Induction & Policy Logs"
                                    position="bottom"
                                  >
                                    <button
                                      onClick={() =>
                                        this.setState(
                                          {
                                            loadingGuestList: `${row?.guest_employee_id}`,
                                          },
                                          () => {
                                            this.GetGuestDataList(row);
                                          }
                                        )
                                      }
                                      type="button"
                                      className="btn-icon btn btn-sm btn-outline-success"
                                    >
                                      {this.state.loadingGuestList ==
                                      row?.guest_employee_id ? (
                                        <span
                                          class="spinner-border flex-shrink-0"
                                          role="status"
                                          style={{
                                            width: "0.8rem",
                                            height: "0.8rem",
                                            borderWidth: "2px",
                                          }}
                                        >
                                          <span class="visually-hidden">
                                            Loading...
                                          </span>
                                        </span>
                                      ) : (
                                        <i className="ri-file-info-line"></i>
                                      )}
                                    </button>
                                  </TooltipComponent>)}
                                  { this.state.decodedData?.includes(3) && (
                                  <TooltipComponent
                                    name="Send Induction Email"
                                    position="bottom"
                                  >
                                    <button
                                      onClick={() =>
                                        this.setState(
                                          {
                                            employee_name: row?.employee_name,
                                            candidateDesignation:
                                              row?.designation_title,
                                            candidateDepartment:
                                              row?.department_title,
                                            candidateGrade: row?.grade_title,
                                            candidateLocation:
                                              row?.location_title,
                                            employee_joining_date:
                                              row?.employee_joining_date,
                                            guest_employee_id:
                                              row?.guest_employee_id,
                                          },
                                          () => {
                                            this.GetPolicyList();
                                          }
                                        )
                                      }
                                      className="btn-icon btn btn-sm btn-outline-info"
                                    >
                                      <i className="ri-mail-send-line"></i>
                                    </button>
                                  </TooltipComponent>)}
                                </td>)}
                              </tr>
                            );
                          })}
                        </tbody>
                      )}
                    </table>
                    <div className="table-light w-100">
                      <div>
                        <div>
                          <div className="d-flex justify-content-between">
                            <button
                              disabled={
                                this.state.prev === false &&
                                this.state.loadingList === false
                                  ? true
                                  : false
                              }
                              type="button"
                              onClick={() => this.handlePrev()}
                              className={`btn btn-warning btn-label waves-effect waves-light`}
                            >
                              <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                              Previous
                            </button>
                            <div
                              className="col-md-4"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {
                                <small>
                                  Total Records: {this.state.total_records} |
                                  Total Pages: {this.state.total_pages} |
                                  Current Page: {this.state.page}
                                </small>
                              }
                            </div>
                            <div className="col-md-2">
                              <select
                                className="form-select"
                                onChange={(e) => this.handleChange(e)}
                              >
                                {Array.from(
                                  { length: this.state.total_pages },
                                  (_, i) => (
                                    <option
                                      selected={this.state.page === i + 1}
                                      key={i}
                                      value={i + 1}
                                    >
                                      Page {i + 1}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                            <div className="col-md-2">
                              <select
                                className="form-select"
                                onChange={this.handleLimitChange}
                                value={this.state.limit}
                              >
                                <option value={this.state.total_records}>All</option>
                                {limitOptions.map((option) => (
                                  <option key={option} value={option}>
                                    Limit {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <button
                              disabled={
                                this.state.next === false &&
                                this.state.loadingList === false
                                  ? true
                                  : false
                              }
                              type="button"
                              onClick={() => this.handleNext()}
                              className={`btn btn-primary btn-label waves-effect right waves-light`}
                            >
                              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {this.state.resendEmail && (
                      <div
                        id="myModal"
                        className="modal show"
                        tabIndex={-1}
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                      >
                        <div
                          className=" bg-light m-auto mt-3"
                          style={{ width: "80%" }}
                        >
                          <div className="modal-content">
                            <div
                              style={{ padding: "10px 10px 0 10px" }}
                              className="modal-header"
                            >
                              <h5 className="modal-title" id="myModalLabel">
                                Send Policy & Email
                              </h5>
                              <button
                                onClick={() => {
                                  this.setState({
                                    resendEmail: false,
                                    isEmailSend: "1",
                                    isEmailModal: false,
                                    emailEdit: false,
                                    emailPreviewClicked: false,
                                    mailTemplateTitle:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_template_title,
                                    mailSubject:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_subject,
                                    mailBody:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_body,
                                    employee_name: "",
                                    candidateDesignation: "",
                                    candidateDepartment: "",
                                    candidateGrade: "",
                                    candidateLocation: "",
                                    employee_joining_date: "",
                                    emailList: false,
                                    selectedPolicyRows: [],
                                  });
                                }}
                                className="btn-close"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <div className="card-body form-steps">
                                <div className="vertical-navs-step">
                                  <div>
                                    <ul
                                      className="nav nav-tabs-custom rounded card-header-tabs border-bottom-1 pb-2 mb-3"
                                      role="tablist"
                                    >
                                      <li
                                        className="nav-item "
                                        role="presentation"
                                        onClick={() =>
                                          this.setState({ isEmailSend: "1" })
                                        }
                                      >
                                        <div
                                          className={`horizontal-tab ${
                                            this.state.isEmailSend === "1"
                                              ? "active-horizontal-tab"
                                              : ""
                                          } cursorPointer`}
                                          role="tab"
                                        >
                                          <i className="ri-file-line" /> Policy
                                        </div>
                                      </li>
                                      <li
                                        className="nav-item"
                                        role="presentation"
                                        onClick={() => {
                                          if (
                                            this.state.selectedPolicyRows
                                              .length > 0
                                          ) {
                                            this.setState({ isEmailSend: "2" });
                                          }
                                        }}
                                      >
                                        <div
                                          className={`horizontal-tab ${
                                            this.state.isEmailSend === "2"
                                              ? "active-horizontal-tab"
                                              : ""
                                          } ${
                                            this.state.selectedPolicyRows
                                              .length === 0
                                              ? "inactive"
                                              : ""
                                          } cursorPointer`}
                                          role="tab"
                                        >
                                          <i className="ri-mail-line" /> Send
                                          Email
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                  {this.state.isEmailSend === "1" ? (
                                    <div className="row">
                                      <div className="">
                                        <table
                                          className={`table table-bordered table-stripped`}
                                        >
                                          <thead className="table-light">
                                            <tr>
                                              <th width={`10%`}>
                                                <div className="d-flex align-items-center gap-2">
                                                  <button
                                                    type="button"
                                                    className="btn p-0"
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input "
                                                      checked={
                                                        this.state
                                                          .selectedPolicyRows
                                                          .length ===
                                                        this.state.policyRows
                                                          .length
                                                      }
                                                      onChange={
                                                        this.handleSelectAll
                                                      }
                                                    />
                                                  </button>
                                                  <p className=" mb-0">
                                                    Select
                                                  </p>
                                                </div>
                                              </th>
                                              <th width={`10%`}>Sr.No.</th>
                                              <th width={`80%`}>
                                                Policy Title
                                              </th>
                                              {/* <th width={`60%`}>Document ID</th> */}
                                              <th
                                                width={`10%`}
                                                className=" text-center"
                                              >
                                                Action
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.policyRows.map(
                                              (row, idx) => {
                                                return (
                                                  <tr
                                                    key={row?.company_policy_id}
                                                  >
                                                    <td>
                                                      <div className="d-flex justify-content-center align-items-center">
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={this.state.selectedPolicyRows.some(
                                                            (item) =>
                                                              (item.company_policy_id || item) ===
                                                              row?.company_policy_id
                                                          )}
                                                          onChange={() =>
                                                            this.handleCheckboxChange(
                                                              row.company_policy_id,
                                                              row?.company_policy_title
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    </td>
                                                    <td>{idx + 1}</td>
                                                    <td>
                                                      {
                                                        row?.company_policy_title
                                                      }
                                                    </td>
                                                    {/* <td>{row?.mail_subject}</td> */}
                                                    <td>
                                                      <TooltipComponent
                                                        name="View Policy Template and Edit"
                                                        position="bottom"
                                                      >
                                                        <button
                                                          onClick={() =>
                                                            this.setState(
                                                              {
                                                                infoLoading: true,
                                                              },
                                                              () => {
                                                                this.GetPolicyInfoSet(
                                                                  idx
                                                                );
                                                              }
                                                            )
                                                          }
                                                          className="btn-icon btn btn-sm btn-outline-success"
                                                        >
                                                          {" "}
                                                          <i className="ri-file-info-line"></i>{" "}
                                                        </button>
                                                      </TooltipComponent>
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            )}
                                          </tbody>
                                          <tfoot className="table-light">
                                            <tr>
                                              <th colSpan={7}>
                                                <div className="d-flex justify-content-between">
                                                  <button
                                                    disabled={
                                                      this.state.doc_prev ===
                                                        false &&
                                                      this.state.loadingList ===
                                                        false
                                                        ? true
                                                        : false
                                                    }
                                                    type="button"
                                                    onClick={() =>
                                                      this.handlePrev("doc")
                                                    }
                                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                                  >
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                    Previous
                                                  </button>
                                                  <div
                                                    className="col-md-4"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    {
                                                      <small>
                                                        Total Records:{" "}
                                                        {
                                                          this.state
                                                            .doc_total_records
                                                        }{" "}
                                                        | Total Pages:{" "}
                                                        {
                                                          this.state
                                                            .doc_total_pages
                                                        }{" "}
                                                        | Current Page:{" "}
                                                        {this.state.doc_page}
                                                      </small>
                                                    }
                                                  </div>
                                                  <div className="col-md-2">
                                                    <select
                                                      className="form-select"
                                                      onChange={(e) =>
                                                        this.handleChange(
                                                          e,
                                                          "doc"
                                                        )
                                                      }
                                                    >
                                                      {Array.from(
                                                        {
                                                          length:
                                                            this.state
                                                              .doc_total_pages,
                                                        },
                                                        (_, i) => (
                                                          <option
                                                            selected={
                                                              this.state
                                                                .doc_page ===
                                                              i + 1
                                                            }
                                                            key={i}
                                                            value={i + 1}
                                                          >
                                                            Page {i + 1}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                  </div>
                                                  <button
                                                    disabled={
                                                      this.state.doc_next ===
                                                        false &&
                                                      this.state.loadingList ===
                                                        false
                                                        ? true
                                                        : false
                                                    }
                                                    type="button"
                                                    onClick={() =>
                                                      this.handleNext("doc")
                                                    }
                                                    className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                  >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                    Next
                                                  </button>
                                                </div>
                                              </th>
                                            </tr>
                                          </tfoot>
                                        </table>
                                      </div>

                                      <div
                                        style={{ padding: "10px 10px 0 10px" }}
                                        className="modal-footer "
                                      >
                                        {/* {this.state.selectedEmailTemplate?
                                                    <button
                                                        type="submit"
                                                        className="btn btn-info btn-label ms-auto waves-effect waves-light"
                                                        onClick={()=> {this.handleCancelEmail(this.state.resendEmail)}} 
                                                    >
                                                        <i className="ri-mail-send-line label-icon align-middle fs-16 me-2" />
                                                        Send
                                                    </button>:null} */}

                                        <button
                                          onClick={() => {
                                            this.setState({
                                              resendEmail: false,
                                              isEmailSend: "1",
                                              mailTemplateTitle:
                                                this.state.email_rows[
                                                  parseInt(
                                                    this.state.isEmailModal
                                                  )
                                                ]?.mail_template_title,
                                              mailSubject:
                                                this.state.email_rows[
                                                  parseInt(
                                                    this.state.isEmailModal
                                                  )
                                                ]?.mail_subject,
                                              mailBody:
                                                this.state.email_rows[
                                                  parseInt(
                                                    this.state.isEmailModal
                                                  )
                                                ]?.mail_body,
                                              isEmailModal: false,
                                              emailEdit: false,
                                              emailPreviewClicked: false,
                                              employee_name: "",
                                              candidateDesignation: "",
                                              candidateDepartment: "",
                                              candidateGrade: "",
                                              candidateLocation: "",
                                              employee_joining_date: "",
                                              emailList: false,
                                              selectedPolicyRows: [],
                                            });
                                          }}
                                          className="btn btn-light"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="row">
                                      {!this.state.emailList ? (
                                        <div className="row">
                                          <table
                                            className={`table table-bordered table-stripped`}
                                          >
                                            <thead className="table-light">
                                              <tr>
                                                <th>Select</th>
                                                <th>Sr.No.</th>
                                                <th width={`30%`}>
                                                  Mail Title
                                                </th>
                                                <th width={`60%`}>
                                                  Mail Subject
                                                </th>

                                                <th
                                                  width={`10%`}
                                                  className=" text-center"
                                                >
                                                  Action
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state.email_rows.map(
                                                (row, idx) => {
                                                  return (
                                                    <tr
                                                      key={
                                                        row?.mail_template_id
                                                      }
                                                    >
                                                      <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={
                                                              this.state
                                                                .selectedEmailTemplate ==
                                                              row?.mail_template_id
                                                            }
                                                            onChange={() =>
                                                              this.setState({
                                                                selectedEmailTemplate:
                                                                  row?.mail_template_id,
                                                              })
                                                            }
                                                          />
                                                        </div>
                                                      </td>
                                                      <td>{idx + 1}</td>
                                                      <td>
                                                        {
                                                          row?.mail_template_title
                                                        }
                                                      </td>
                                                      <td>
                                                        {row?.mail_subject}
                                                      </td>
                                                      <td className="d-flex justify-content-around">
                                                        {/* <button onClick={() => handleDelete(row?.mail_template_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                                        <TooltipComponent
                                                          name="View Email Template and Edit"
                                                          position="bottom"
                                                        >
                                                          {this.state
                                                            .infoLoading ===
                                                          row?.mail_template_id ? (
                                                            <button className="btn btn-success btn-load">
                                                              <span className="d-flex align-items-center">
                                                                <span
                                                                  className="spinner-border flex-shrink-0"
                                                                  role="status"
                                                                >
                                                                  <span className="visually-hidden">
                                                                    Loading...
                                                                  </span>
                                                                </span>
                                                                {/* <span className="flex-grow-1 ms-2">
                                                                        Loading...
                                                                        </span> */}
                                                              </span>
                                                            </button>
                                                          ) : (
                                                            <button
                                                              className="btn-icon btn btn-sm btn-outline-success"
                                                              onClick={() =>
                                                                this.getInfo(
                                                                  row?.mail_template_id,
                                                                  idx
                                                                )
                                                              }
                                                            >
                                                              {" "}
                                                              <i className="ri-file-info-line"></i>{" "}
                                                            </button>
                                                          )}
                                                        </TooltipComponent>
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                            </tbody>
                                            <tfoot className="table-light">
                                              <tr>
                                                <th colSpan={7}>
                                                  <div className="d-flex justify-content-between">
                                                    <button
                                                      disabled={
                                                        this.state
                                                          .email_prev ===
                                                          false &&
                                                        this.state
                                                          .loadingList === false
                                                          ? true
                                                          : false
                                                      }
                                                      type="button"
                                                      onClick={() =>
                                                        this.handlePrev("email")
                                                      }
                                                      className={`btn btn-warning btn-label waves-effect waves-light`}
                                                    >
                                                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                      Previous
                                                    </button>
                                                    <div
                                                      className="col-md-4"
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      {
                                                        <small>
                                                          Total Records:{" "}
                                                          {
                                                            this.state
                                                              .email_total_records
                                                          }{" "}
                                                          | Total Pages:{" "}
                                                          {
                                                            this.state
                                                              .email_total_pages
                                                          }{" "}
                                                          | Current Page:{" "}
                                                          {
                                                            this.state
                                                              .email_page
                                                          }
                                                        </small>
                                                      }
                                                    </div>
                                                    <div className="col-md-2">
                                                      <select
                                                        className="form-select"
                                                        onChange={(e) =>
                                                          this.handleChange(
                                                            e,
                                                            "email"
                                                          )
                                                        }
                                                      >
                                                        {Array.from(
                                                          {
                                                            length:
                                                              this.state
                                                                .email_total_pages,
                                                          },
                                                          (_, i) => (
                                                            <option
                                                              selected={
                                                                this.state
                                                                  .email_page ===
                                                                i + 1
                                                              }
                                                              key={i}
                                                              value={i + 1}
                                                            >
                                                              Page {i + 1}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </div>
                                                    <button
                                                      disabled={
                                                        this.state
                                                          .email_next ===
                                                          false &&
                                                        this.state
                                                          .loadingList === false
                                                          ? true
                                                          : false
                                                      }
                                                      type="button"
                                                      onClick={() =>
                                                        this.handleNext("email")
                                                      }
                                                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                    >
                                                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                      Next
                                                    </button>
                                                  </div>
                                                </th>
                                              </tr>
                                            </tfoot>
                                          </table>
                                        </div>
                                      ) : (
                                        <div className="modal-body">
                                          <div className="">
                                            <div className="">
                                              <div className="card-body">
                                                {!this.state.emailEdit ? (
                                                  <div>
                                                    <div className="row gy-4">
                                                      <div className="col-md-12 mb-1 mt-0">
                                                        <label
                                                          htmlFor="mailTemplateTitle"
                                                          className="form-label"
                                                        >
                                                          Title:
                                                        </label>
                                                        <input
                                                          type="text"
                                                          id="mailTemplateTitle"
                                                          name="mailTemplateTitle"
                                                          disabled
                                                          value={
                                                            this.state
                                                              .email_rows[
                                                              parseInt(
                                                                this.state
                                                                  .isEmailModal
                                                              )
                                                            ]
                                                              ?.mail_template_title
                                                          }
                                                          // onChange={e => this.handleInputChange(e)}
                                                          className={`form-control`}
                                                          placeholder="Template Title"
                                                        />
                                                      </div>
                                                      <div className="col-md-12 mb-0 mt-0">
                                                        <label
                                                          htmlFor="mailSubject"
                                                          className="form-label"
                                                        >
                                                          Subject:
                                                        </label>
                                                        <input
                                                          type="text"
                                                          id="mailSubject"
                                                          name="mailSubject"
                                                          disabled
                                                          value={
                                                            this.state
                                                              .email_rows[
                                                              parseInt(
                                                                this.state
                                                                  .isEmailModal
                                                              )
                                                            ]?.mail_subject
                                                          }
                                                          // onChange={e =>
                                                          //   this.handleInputChange(e)
                                                          // }
                                                          className={`form-control`}
                                                          placeholder="Subject"
                                                        />
                                                      </div>
                                                      <div className="col-md-12 mb-3 mt-0">
                                                        <label
                                                          htmlFor="mailSubject"
                                                          className="form-label"
                                                        >
                                                          Body:
                                                        </label>
                                                        <div
                                                          style={{
                                                            border:
                                                              "1px solid gray",
                                                            backgroundColor:
                                                              "#EFF2F7",
                                                            borderRadius:
                                                              "10px",
                                                          }}
                                                          className=" px-3 py-2"
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              this.state
                                                                .email_rows[
                                                                parseInt(
                                                                  this.state
                                                                    .isEmailModal
                                                                )
                                                              ]?.mail_body ||
                                                              "",
                                                          }}
                                                        />
                                                      </div>
                                                      <div>
                                                        {!this.state
                                                          .emailEdit ? (
                                                          <button
                                                            style={{
                                                              marginRight:
                                                                "10px",
                                                            }}
                                                            onClick={() => {
                                                              this.setState({
                                                                emailEdit: true,
                                                              });
                                                            }}
                                                            className="btn btn-warning"
                                                          >
                                                            {"Edit"}
                                                          </button>
                                                        ) : (
                                                          ""
                                                        )}
                                                        <button
                                                          onClick={() => {
                                                            this.setState({
                                                              isEmailModal: false,
                                                              emailEdit: false,
                                                              emailPreviewClicked: false,
                                                              emailList: false,
                                                            });
                                                          }}
                                                          className="btn btn-light"
                                                        >
                                                          Back
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : !this.state
                                                    .emailPreviewClicked ? (
                                                  <>
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                      <button
                                                        type="button"
                                                        className={`${
                                                          this.state.mailBody
                                                            ? ""
                                                            : "d-none"
                                                        } btn btn-primary btn-label mx-2`}
                                                        onClick={() =>
                                                          this.setState(
                                                            {
                                                              emailPreviewClicked: true,
                                                            },
                                                            () => {
                                                              this.templatePreview(
                                                                "email"
                                                              );
                                                            }
                                                          )
                                                        } // Add onClick handler for preview button
                                                      >
                                                        Preview
                                                        <i className="ri-eye-line label-icon align-middle fs-16" />
                                                      </button>
                                                      <button
                                                        type="button"
                                                        className="btn btn-primary waves-effect right waves-light btn-label"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#offcanvasRight"
                                                        aria-controls="offcanvasRight"
                                                      >
                                                        <i className="ri-code-s-slash-line label-icon align-middle fs-16" />{" "}
                                                        Placeholder Keys
                                                      </button>
                                                    </div>
                                                    <div
                                                      className="offcanvas offcanvas-end"
                                                      tabIndex={-1}
                                                      id="offcanvasRight"
                                                      aria-labelledby="offcanvasRightLabel"
                                                    >
                                                      <div className="offcanvas-header">
                                                        <h5 id="offcanvasRightLabel">
                                                          {" "}
                                                          Placeholder Keys
                                                        </h5>
                                                        <button
                                                          type="button"
                                                          className="btn-close text-reset"
                                                          data-bs-dismiss="offcanvas"
                                                          aria-label="Close"
                                                        />
                                                      </div>

                                                      <div className="offcanvas-body">
                                                        <table class="table table-hover table-bordered border-primary table-nowrap">
                                                          <thead className="bg-primary text-light bg-gradient">
                                                            <tr>
                                                              <th scope="col">
                                                                Names
                                                              </th>
                                                              <th scope="col">
                                                                Code
                                                              </th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            <tr>
                                                              <td>
                                                                Current Date
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##current_date##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##current_date##
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                Employee Panel
                                                                Link
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##employee_panel_url##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##employee_panel_url##
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                User Credentials
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##user_credentials##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##user_credentials##
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                Employee Name
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##employee_name##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##employee_name##
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                Department Title
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##department_title##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##department_title##
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                Designation
                                                                Title
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##designation_title##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##designation_title##
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                Grade Title
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##grade_title##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##grade_title##
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                Location Title
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##location_title##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##location_title##
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                Employee Joining
                                                                Date
                                                              </td>
                                                              <td
                                                                onClick={() =>
                                                                  this.handleCopyClick(
                                                                    "##employee_joining_date##"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                ##employee_joining_date##
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                    <form
                                                      className=" mt-3"
                                                      onSubmit={() =>
                                                        this.handleEmail()
                                                      }
                                                    >
                                                      <div className="row gy-4">
                                                        <div className="col-md-12 mb-1 mt-3">
                                                          <label
                                                            htmlFor="mailTemplateTitle"
                                                            className="form-label"
                                                          >
                                                            Title:
                                                          </label>
                                                          <input
                                                            type="text"
                                                            id="mailTemplateTitle"
                                                            name="mailTemplateTitle"
                                                            value={
                                                              this.state
                                                                .mailTemplateTitle
                                                            }
                                                            disabled
                                                            onChange={(e) =>
                                                              this.handleEmailInputChange(
                                                                e
                                                              )
                                                            }
                                                            className={`form-control ${
                                                              this.state.errors
                                                                .mailTemplateTitle
                                                                ? "is-invalid"
                                                                : ""
                                                            }`}
                                                            placeholder="Enter Template Title"
                                                          />

                                                          {this.state.errors
                                                            .mailTemplateTitle && (
                                                            <div className="invalid-feedback">
                                                              {
                                                                this.state
                                                                  .errors
                                                                  .mailTemplateTitle
                                                              }
                                                            </div>
                                                          )}
                                                        </div>
                                                        <div className="col-md-12 mb-3 mt-0">
                                                          <label
                                                            htmlFor="mailSubject"
                                                            className="form-label"
                                                          >
                                                            Subject:
                                                          </label>
                                                          <input
                                                            type="text"
                                                            id="mailSubject"
                                                            name="mailSubject"
                                                            value={
                                                              this.state
                                                                .mailSubject
                                                            }
                                                            disabled
                                                            onChange={(e) =>
                                                              this.handleEmailInputChange(
                                                                e
                                                              )
                                                            }
                                                            className={`form-control ${
                                                              this.state.errors
                                                                .mailSubject
                                                                ? "is-invalid"
                                                                : ""
                                                            }`}
                                                            placeholder="Enter Subject"
                                                          />

                                                          {this.state.errors
                                                            .mailSubject && (
                                                            <div className="invalid-feedback">
                                                              {
                                                                this.state
                                                                  .errors
                                                                  .mailSubject
                                                              }
                                                            </div>
                                                          )}
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <CKEditor
                                                          editor={ClassicEditor}
                                                          data={
                                                            this.state.mailBody
                                                          }
                                                          name={"mailBody"}
                                                          onChange={
                                                            this
                                                              .handleEditorEmailChange
                                                          }
                                                        />
                                                        {this.state.errors
                                                          .mailBody && (
                                                          <div
                                                            style={{
                                                              fontSize: "12px",
                                                            }}
                                                            className=" text-danger"
                                                          >
                                                            {
                                                              this.state.errors
                                                                .mailBody
                                                            }
                                                          </div>
                                                        )}
                                                        <div
                                                          style={{
                                                            marginTop: "30px",
                                                            marginLeft: "Auto",
                                                          }}
                                                        >
                                                          <button
                                                            // disabled={loading}
                                                            style={{
                                                              marginRight:
                                                                "10px",
                                                            }}
                                                            type="submit"
                                                            className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                          >
                                                            <i
                                                              className={`ri-save-line label-icon align-middle fs-16 ms-2`}
                                                            />
                                                            {"Save"}
                                                          </button>
                                                          <button
                                                            onClick={() =>
                                                              this.setState({
                                                                emailEdit: false,
                                                                emailList: false,
                                                              })
                                                            }
                                                            className={`btn btn-danger btn-label waves-effect right waves-light float-right`}
                                                          >
                                                            <i
                                                              className={`ri-save-line label-icon align-middle fs-16 ms-2`}
                                                            />
                                                            {"Cancel"}
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </form>
                                                  </>
                                                ) : (
                                                  <div>
                                                    <div className="row gy-4">
                                                      <div>
                                                        <button
                                                          onClick={() => {
                                                            this.setState({
                                                              emailPreviewClicked: false,
                                                            });
                                                          }}
                                                          className="btn btn-warning"
                                                        >
                                                          {"Editor"}
                                                        </button>
                                                      </div>
                                                      <div className="col-md-12 mb-1 mt-0">
                                                        <label
                                                          htmlFor="mailTemplateTitle"
                                                          className="form-label"
                                                        >
                                                          Title:
                                                        </label>
                                                        <input
                                                          type="text"
                                                          id="mailTemplateTitle"
                                                          name="mailTemplateTitle"
                                                          disabled
                                                          value={
                                                            this.state
                                                              .email_rows[
                                                              parseInt(
                                                                this.state
                                                                  .isEmailModal
                                                              )
                                                            ]
                                                              ?.mail_template_title
                                                          }
                                                          // onChange={e => this.handleInputChange(e)}
                                                          className={`form-control`}
                                                          placeholder="Template Title"
                                                        />
                                                      </div>
                                                      <div className="col-md-12 mb-0 mt-0">
                                                        <label
                                                          htmlFor="mailSubject"
                                                          className="form-label"
                                                        >
                                                          Subject:
                                                        </label>
                                                        <input
                                                          type="text"
                                                          id="mailSubject"
                                                          name="mailSubject"
                                                          disabled
                                                          value={
                                                            this.state
                                                              .email_rows[
                                                              parseInt(
                                                                this.state
                                                                  .isEmailModal
                                                              )
                                                            ]?.mail_subject
                                                          }
                                                          // onChange={e =>
                                                          //   this.handleInputChange(e)
                                                          // }
                                                          className={`form-control`}
                                                          placeholder="Subject"
                                                        />
                                                      </div>
                                                      <div className="col-md-12 mb-3 mt-0">
                                                        <label
                                                          htmlFor="mailSubject"
                                                          className="form-label"
                                                        >
                                                          Body:
                                                        </label>
                                                        <div
                                                          style={{
                                                            border:
                                                              "1px solid gray",
                                                            backgroundColor:
                                                              "#EFF2F7",
                                                            borderRadius:
                                                              "10px",
                                                          }}
                                                          className=" px-3 py-2"
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              this.state
                                                                .email_preview ||
                                                              "",
                                                          }}
                                                        />
                                                      </div>
                                                      <div>
                                                        {!this.state
                                                          .emailEdit ? (
                                                          <button
                                                            onClick={() => {
                                                              this.setState({
                                                                emailEdit: true,
                                                              });
                                                            }}
                                                            className="btn btn-warning"
                                                          >
                                                            {"Editor"}
                                                          </button>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      <div
                                        style={{ padding: "10px 10px 0 10px" }}
                                        className="modal-footer"
                                      >
                                        {this.state.selectedEmailTemplate ? (
                                          !this.state.loadingSendEmail ? (
                                            <button
                                              type="submit"
                                              className="btn btn-info btn-label ms-auto waves-effect waves-light"
                                              onClick={() => {
                                                this.handleSendEmail();
                                              }}
                                            >
                                              <i className="ri-mail-send-line label-icon align-middle fs-16 me-2" />
                                              Send
                                            </button>
                                          ) : (
                                            <button className="btn btn-info btn-load">
                                              <span className="d-flex align-items-center">
                                                <span
                                                  className="spinner-border flex-shrink-0"
                                                  role="status"
                                                >
                                                  <span className="visually-hidden">
                                                    Loading...
                                                  </span>
                                                </span>
                                                <span className="flex-grow-1 ms-2">
                                                  Loading...
                                                </span>
                                              </span>
                                            </button>
                                          )
                                        ) : null}

                                        <button
                                          onClick={() => {
                                            this.setState({
                                              resendEmail: false,
                                              isEmailSend: "1",
                                              mailTemplateTitle:
                                                this.state.email_rows[
                                                  parseInt(
                                                    this.state.isEmailModal
                                                  )
                                                ]?.mail_template_title,
                                              mailSubject:
                                                this.state.email_rows[
                                                  parseInt(
                                                    this.state.isEmailModal
                                                  )
                                                ]?.mail_subject,
                                              mailBody:
                                                this.state.email_rows[
                                                  parseInt(
                                                    this.state.isEmailModal
                                                  )
                                                ]?.mail_body,
                                              isEmailModal: false,
                                              emailEdit: false,
                                              emailPreviewClicked: false,
                                              employee_name: "",
                                              candidateDesignation: "",
                                              candidateDepartment: "",
                                              candidateGrade: "",
                                              candidateLocation: "",
                                              employee_joining_date: "",
                                              emailList: false,
                                              selectedPolicyRows: [],
                                            });
                                          }}
                                          className="btn btn-light"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.isPolicyModal && (
                      <div
                        id="myModal"
                        className="modal show"
                        tabIndex={-1}
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-lg">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="myModalLabel">
                                Policy Template
                              </h5>

                              <button
                                onClick={() => {
                                  this.setState({
                                    isPolicyModal: false,
                                    company_policy_title: "",
                                    company_policy_content_type: "",
                                    policy_content: "",
                                    policy_url: "",
                                  });
                                }}
                                className="btn-close"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <div className="">
                                <div className="mt-3">
                                  <div className="">
                                    <>
                                      {/* preview */}
                                      <div className="card-body">
                                        <h5 className=" py-1">
                                          Policy Title:
                                          {
                                            this.state.policyRows[
                                              parseInt(this.state.isPolicyModal)
                                            ]?.company_policy_title
                                          }
                                        </h5>
                                        <div
                                          className={`m-auto rounded-3 `}
                                          style={{
                                            // width: "100%",
                                            height: "120vh",
                                            border: "1px solid #ccc",
                                          }}
                                        >
                                          {this.state
                                            .company_policy_content_type ===
                                          "1" ? (
                                            this.state.policy_url ? (
                                              <iframe
                                                src={this.state.policy_url}
                                                title="PDF Viewer"
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                }}
                                                frameBorder="0"
                                              >
                                                This browser does not support
                                                embedded files.
                                              </iframe>
                                            ) : (
                                              <h4 className="text-muted px-3 py-2">
                                                No Preview available.
                                              </h4>
                                            )
                                          ) : this.state.policy_content ? (
                                            <div
                                              className=" p-3 overflow-y-scroll"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  this.state.policy_content,
                                              }}
                                            />
                                          ) : (
                                            <h4 className="text-muted px-3 py-2">
                                              No Preview available.
                                            </h4>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                onClick={() => {
                                  this.setState({
                                    isPolicyModal: false,
                                    company_policy_title: "",
                                    company_policy_content_type: "",
                                    policy_content: "",
                                    policy_url: "",
                                  });
                                }}
                                className="btn btn-light"
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.viewOfferLetterLogs ? (
                      <div
                        id="myModal"
                        className="modal show"
                        tabIndex={-1}
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                      >
                        <div
                          className=" bg-light m-3"
                          style={{ width: "98%" }} // Custom width for the modal
                        >
                          <div className="modal-content">
                            <div className="">
                              <div
                                style={{
                                  borderBottom:
                                    "1px solid var(--vz-border-color)",
                                }}
                                className=" py-3 px-3 d-flex justify-content-between align-items-center"
                              >
                                <h4 className="card-title mb-0">
                                  Induction Logs
                                </h4>
                                <button
                                  onClick={() => {
                                    this.setState({
                                      viewOfferLetterInfo: false,
                                      viewOfferLetterLogs: false,
                                    });
                                  }}
                                  className="btn-close"
                                  aria-label="Close"
                                ></button>
                              </div>
                            </div>
                            <div
                              style={{ padding: "0 10px 10px 10px" }}
                              className="modal-body"
                            >
                              <div
                                // style={{ padding: "0 10px 10px 10px" }}
                                className="card-body form-steps"
                              >
                                <div className="vertical-navs-step pt-3">
                                  <div className="row gy-5">
                                    <div className="col-md-3">
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns: "1fr",
                                        }}
                                        className="nav gap-2"
                                      >
                                        <button
                                          className={`nav-tab d-flex justify-content-start align-items-center gap-2  ${
                                            this.state.selectedInfoTab === "1"
                                              ? "active-tab"
                                              : ""
                                          }`}
                                          id="v-pills-bill-address-tab"
                                          // data-bs-toggle='pill'
                                          // data-bs-target='#v-pills-bill-address'
                                          type="button"
                                          role="tab"
                                          onClick={() =>
                                            this.setState({
                                              selectedInfoTab: "1",
                                            })
                                          }
                                        >
                                          <i
                                            className="ri-file-list-3-line text-primary fs-20 mr-3"
                                            style={{ fontSize: "24px" }}
                                          />
                                          Policy Details
                                        </button>
                                        <button
                                          className={`nav-tab d-flex justify-content-start align-items-center gap-1 ${
                                            this.state.selectedInfoTab === "2"
                                              ? "active-tab"
                                              : ""
                                          }`}
                                          id="v-pills-bill-info-tab"
                                          type="button"
                                          role="tab"
                                          onClick={() =>
                                            this.setState({
                                              selectedInfoTab: "2",
                                            })
                                          }
                                        >
                                          <i
                                            className="ri-mail-line text-primary fs-20 mr-3"
                                            style={{ fontSize: "24px" }}
                                          />
                                          Email Details
                                        </button>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        minHeight: "66vh",
                                        maxHeight: "66vh",
                                        overflowY: "scroll",
                                        //   marginTop:"0",
                                        //   paddingTop:"3rem",
                                      }}
                                      className="col-lg-9"
                                    >
                                      <div className="tab-content">
                                        {/* Letter Details */}
                                        {this.state.selectedInfoTab === "1" && (
                                          <div
                                            className=""
                                            // id='v-pills-email'
                                            // role='tabpanel'
                                            // aria-labelledby='v-pills-email-tab'
                                          >
                                            <div>
                                              <h5>Policy Details</h5>
                                            </div>
                                            <div className="row">
                                              <table
                                                className={`table table-bordered table-hover`}
                                              >
                                                <thead className="table-light  sticky-top z-1">
                                                  <tr>
                                                    <th>Sr.No.</th>
                                                    <th>Sent Date</th>
                                                    <th>Policy Lists</th>
                                                    <th>Status</th>
                                                    {/* <th
                                                      width={`10%`}
                                                      className=" text-center"
                                                    >
                                                      Action
                                                    </th> */}
                                                  </tr>
                                                </thead>

                                                {this.state.logs_rows
                                                  ?.employee_induction_details
                                                  ?.length === 0 ? (
                                                  <tbody>
                                                    <tr>
                                                      <td colSpan={12}>
                                                        <NoRecords />
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                ) : (
                                                  <tbody>
                                                    {this.state.logs_rows?.employee_induction_details?.map(
                                                      (row, idx) => {
                                                        return (
                                                          <tr
                                                            key={
                                                              row?.company_policy_id
                                                            }
                                                          >
                                                            <td>{idx + 1}</td>
                                                            <td>
                                                              {row?.created_date
                                                                ? formatDateWithTime(
                                                                    row?.created_date
                                                                  )
                                                                : "--"}
                                                            </td>
                                                            <td>
                                                              {
                                                                row?.company_policy_title
                                                              }
                                                            </td>
                                                            <td>
                                                              <div
                                                                style={{
                                                                  fontSize:
                                                                    "0.65rem",
                                                                }}
                                                                className={` bg-${row?.employees_induction_status_classes} fw-semibold px-1 text-center py-1 text-white rounded-4`}
                                                              >
                                                                {
                                                                  row?.employees_induction_status
                                                                }
                                                              </div>
                                                            </td>
                                                            {/* <td>
                                                                <button
                                                                  onClick={() =>
                                                                    this.setState(
                                                                      {
                                                                        infoLoading: true,
                                                                      },
                                                                      () => {
                                                                        this.GetLetterInfo(
                                                                          idx
                                                                        );
                                                                      }
                                                                    )
                                                                  }
                                                                  className="btn-icon btn btn-sm btn-outline-success"
                                                                >
                                                                  {" "}
                                                                  <i className="ri-file-info-line"></i>{" "}
                                                                </button>
                                                              </td> */}
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </tbody>
                                                )}
                                              </table>
                                            </div>
                                            {this.state.isLetterModal && (
                                              <div
                                                id="myModal"
                                                className="modal show"
                                                tabIndex={-1}
                                                style={{
                                                  display: "block",
                                                  backgroundColor:
                                                    "rgba(0, 0, 0, 0.5)",
                                                }}
                                                aria-labelledby="myModalLabel"
                                                aria-hidden="true"
                                              >
                                                <div className="modal-dialog modal-lg">
                                                  <div className="modal-content">
                                                    <div className="modal-header">
                                                      <h5
                                                        className="modal-title"
                                                        id="myModalLabel"
                                                      >
                                                        Letter Template
                                                      </h5>

                                                      <button
                                                        onClick={() => {
                                                          this.setState({
                                                            isLetterModal: false,
                                                            letterEdit: false,
                                                            previewClicked: false,
                                                          });
                                                        }}
                                                        className="btn-close"
                                                        aria-label="Close"
                                                      ></button>
                                                    </div>
                                                    <div className="modal-body">
                                                      <div className="">
                                                        <div className="mt-3">
                                                          <div className="">
                                                            <div>
                                                              <div className="card-body">
                                                                <h5 className=" py-1 px-4">
                                                                  Letter Title:{" "}
                                                                  {
                                                                    this.state
                                                                      .company_letter_title
                                                                  }
                                                                </h5>
                                                                {/* <h5 className=' py-2 px-4'></h5> */}
                                                                {this.state
                                                                  .company_letter_content &&
                                                                this.state
                                                                  .letterhead_url ? (
                                                                  this.renderPages(
                                                                    this.state
                                                                      .company_letter_content,
                                                                    this.state
                                                                      .letterhead_url,
                                                                    this.state
                                                                      .markings
                                                                  )
                                                                ) : (
                                                                  <h4 className="text-muted">
                                                                    No Preview
                                                                    available.
                                                                  </h4>
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                      <button
                                                        onClick={() => {
                                                          this.setState({
                                                            isLetterModal: false,
                                                            letterEdit: false,
                                                            previewClicked: false,
                                                          });
                                                        }}
                                                        className="btn btn-light"
                                                      >
                                                        Close
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        {/* Email Details */}
                                        {this.state.selectedInfoTab === "2" && (
                                          <div>
                                            <div>
                                              <div>
                                                <h5>Email Details</h5>
                                              </div>
                                              <div className="row">
                                                <table
                                                  className={`table table-bordered table-stripped`}
                                                >
                                                  <thead className="table-light sticky-top z-1">
                                                    <tr>
                                                      <th>Sr.No.</th>
                                                      <th>Issued Date</th>
                                                      <th width={`30%`}>
                                                        Mail Title
                                                      </th>
                                                      <th width={`30%`}>
                                                        Mail Subject
                                                      </th>

                                                      <th
                                                        width={`10%`}
                                                        className=" text-center"
                                                      >
                                                        Action
                                                      </th>
                                                    </tr>
                                                  </thead>

                                                  {this.state.logs_rows
                                                    ?.employee_mail_details
                                                    ?.length === 0 ? (
                                                    <tbody>
                                                      <tr>
                                                        <td colSpan={12}>
                                                          <NoRecords />
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  ) : (
                                                    <tbody>
                                                      {this.state.logs_rows?.employee_mail_details?.map(
                                                        (row, idx) => {
                                                          return (
                                                            <tr
                                                              key={
                                                                row?.mail_template_id
                                                              }
                                                            >
                                                              <td>{idx + 1}</td>
                                                              <td>
                                                                {row?.log_date
                                                                  ? formatDateWithTime(
                                                                      row?.log_date
                                                                    )
                                                                  : "--"}
                                                              </td>
                                                              <td>
                                                                {
                                                                  row?.mail_template_title
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  row?.email_subject
                                                                }
                                                              </td>
                                                              <td className="d-flex justify-content-around">
                                                                <button
                                                                  onClick={() =>
                                                                    this.setState(
                                                                      {
                                                                        infoLoading:
                                                                          row?.mail_template_id,
                                                                      },
                                                                      () => {
                                                                        this.getEmailInfo(
                                                                          row?.mail_template_id,
                                                                          idx
                                                                        );
                                                                      }
                                                                    )
                                                                  }
                                                                  className="btn-icon btn btn-sm btn-outline-success"
                                                                >
                                                                  {" "}
                                                                  <i className="ri-file-info-line"></i>{" "}
                                                                </button>
                                                              </td>
                                                            </tr>
                                                          );
                                                        }
                                                      )}
                                                    </tbody>
                                                  )}
                                                </table>
                                              </div>
                                              {this.state.isEmailModal && (
                                                <div
                                                  id="myModal"
                                                  className="modal show"
                                                  tabIndex={-1}
                                                  style={{
                                                    display: "block",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                  }}
                                                  aria-labelledby="myModalLabel"
                                                  aria-hidden="true"
                                                >
                                                  <div className="modal-dialog modal-lg">
                                                    <div className="modal-content">
                                                      <div className="modal-header">
                                                        <h5
                                                          className="modal-title"
                                                          id="myModalLabel"
                                                        >
                                                          Email Template
                                                        </h5>

                                                        <button
                                                          onClick={() => {
                                                            this.setState({
                                                              isEmailModal: false,
                                                              emailEdit: false,
                                                              emailPreviewClicked: false,
                                                              mailTemplateTitle:
                                                                this.state
                                                                  .email_rows[
                                                                  parseInt(
                                                                    this.state
                                                                      .isEmailModal
                                                                  )
                                                                ]
                                                                  ?.mail_template_title,
                                                              mailSubject:
                                                                this.state
                                                                  .email_rows[
                                                                  parseInt(
                                                                    this.state
                                                                      .isEmailModal
                                                                  )
                                                                ]?.mail_subject,
                                                              mailBody:
                                                                this.state
                                                                  .email_rows[
                                                                  parseInt(
                                                                    this.state
                                                                      .isEmailModal
                                                                  )
                                                                ]?.mail_body,
                                                            });
                                                          }}
                                                          className="btn-close"
                                                          aria-label="Close"
                                                        ></button>
                                                      </div>
                                                      <div className="modal-body">
                                                        <div className="">
                                                          <div className="">
                                                            <div className="card-body">
                                                              <div>
                                                                <div className="row gy-4">
                                                                  <div className="col-md-12 mb-1 mt-0">
                                                                    <label
                                                                      htmlFor="mailTemplateTitle"
                                                                      className="form-label"
                                                                    >
                                                                      Title:
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      id="mailTemplateTitle"
                                                                      name="mailTemplateTitle"
                                                                      disabled
                                                                      value={
                                                                        this
                                                                          .state
                                                                          .mailTemplateTitle
                                                                      }
                                                                      className={`form-control`}
                                                                      placeholder="Template Title"
                                                                    />
                                                                  </div>
                                                                  <div className="col-md-12 mb-0 mt-0">
                                                                    <label
                                                                      htmlFor="mailSubject"
                                                                      className="form-label"
                                                                    >
                                                                      Subject:
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      id="mailSubject"
                                                                      name="mailSubject"
                                                                      disabled
                                                                      value={
                                                                        this
                                                                          .state
                                                                          .mailSubject
                                                                      }
                                                                      className={`form-control`}
                                                                      placeholder="Subject"
                                                                    />
                                                                  </div>
                                                                  <div className="col-md-12 mb-3 mt-0">
                                                                    <label
                                                                      htmlFor="mailSubject"
                                                                      className="form-label"
                                                                    >
                                                                      Body:
                                                                    </label>
                                                                    <div
                                                                      style={{
                                                                        border:
                                                                          "1px solid gray",
                                                                        backgroundColor:
                                                                          "#EFF2F7",
                                                                        borderRadius:
                                                                          "10px",
                                                                      }}
                                                                      className=" px-3 py-2"
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          this
                                                                            .state
                                                                            .mailBody ||
                                                                          "",
                                                                      }}
                                                                    />
                                                                  </div>
                                                                  <div></div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="modal-footer">
                                                        <button
                                                          onClick={() => {
                                                            this.setState({
                                                              isEmailModal: false,
                                                              emailEdit: false,
                                                              emailPreviewClicked: false,
                                                            });
                                                          }}
                                                          className="btn btn-light"
                                                        >
                                                          Close
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  {/* end col */}
                                </div>
                                {/* end row */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(InductionProcess);
